import React, { useMemo, Suspense } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Navigation from './Navigation';
import SignupPage from './SignUp';
import SignInPage from './SignIn';
import LoadingScreen from './Loading';

import * as ROUTES from '../constants/routes';
import TranscriptsList from './TranscriptsList';
import { ThemeProvider, createMuiTheme } from '@material-ui/core';
import { useAuthentication, AuthProvider } from './Session';

const PasswordForgetPage = React.lazy(() => import('./PasswordForget.js'));
const AccountPage = React.lazy(() => import('./Account'));
const AdminPage = React.lazy(() => import('./Admin'));
const AddNewTranscript = React.lazy(() => import('./AddNewTranscript'));
const EditorWithControls = React.lazy(() => import('./Editor'));

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const authUser = useAuthentication();
  return (
    <Route
      {...rest}
      render={props =>
        authUser.authenticated === true ? (
          <React.Fragment>
            <Navigation />
            <Component {...props} />
          </React.Fragment>
        ) : (
          <Redirect
            to={{
              pathname: ROUTES.SIGN_IN,
              state: { referrer: props.location }
            }}
          />
        )
      }
    />
  );
};

const App = () => {
  console.debug('calling App');
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  /**
   * {
        palette: {
          type: prefersDarkMode ? 'dark' : 'light'
        }
      }
   */
  const theme = useMemo(
    () =>
      createMuiTheme({
        palette: {
          primary: {
            light: '#48a999',
            main: '#00796b',
            dark: '#004c40',
            contrastText: '#fff'
          },
          secondary: {
            light: '#ffd149',
            main: '#ffa000',
            dark: '#c67100',
            contrastText: '#000'
          }
        }
      }),
    []
  );

  return (
    <ThemeProvider theme={theme}>
      <Router basename={process.env.PUBLIC_URL}>
        <AuthProvider>
          <Suspense fallback={<LoadingScreen />}>
            <div>
              <ProtectedRoute exact path={'/'} component={TranscriptsList} />
              <ProtectedRoute
                exact
                path={ROUTES.TRANSCRIPTION_LIST}
                component={TranscriptsList}
              />
              <ProtectedRoute path={ROUTES.ACCOUNT} component={AccountPage} />
              <ProtectedRoute path={ROUTES.ADMIN} component={AdminPage} />
              <ProtectedRoute
                path={ROUTES.NEW_TRANSCRIPT}
                component={AddNewTranscript}
              />
              <ProtectedRoute
                path={ROUTES.TRANSCRIPT_EDITOR}
                component={EditorWithControls}
              />
              <Route path={ROUTES.SIGN_UP} component={SignupPage} />
              <Route path={ROUTES.SIGN_IN} component={SignInPage} />
              <Route
                path={ROUTES.PASSWORD_FORGET}
                component={PasswordForgetPage}
              />
            </div>
          </Suspense>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
